import React, { Component } from "react";
import EkoModal from "../../components/elements/EkoModal";
import EkoInputTable from "../../components/elements/EkoInputTable";
import { toastr } from "react-redux-toastr";
import Util from "../../util/Util";
class InvoiceCustomerLineModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [this.row],
            errors: {
                rows: []
            },
            saving: false,
            hideAddButton: true,
            formData:this.props.invoiceCustomRows
        };
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.showInvoiceCustomModal !== this.props.showInvoiceCustomModal && this.props.showInvoiceCustomModal) {
            this.setState({ formData: this.props.invoiceCustomRows })
        }
    }
    get row() {
        return [
            {
                label: "",
                placeholder: "id",
                type: "text",
                colMd: 12,
                id: "id",
                visible:true
            },
            {
                label: "",
                placeholder: "Etiket",
                type: "text",
                colMd: 12,
                id: "key",
                vertical:true
            },{
                label: "",
                placeholder: "Değer",
                type: "text",
                colMd: 12,
                id: "val",
                vertical:true
            },
        ];
    }

    checkValid = data => {
        return !!(data && data !== "");
    };

    onSave = () => {
        const errors = this.checkErrors();
        this.setState({ errors: { rows: errors } });
        if (errors.length === 0) {
            this.props.closeInvoiceCustomModal();
        }
        if(this.props.directInsertUpdate && this.props.directInsertUpdate===true){
            this.props.directInsertUpdateFunc(this.state.formData.rows);
        }
    };

    checkErrors = () => {
        const rows = this.state.formData.rows;

        const errors = [];

        rows.map((row, index) => {
            if (this.checkValid(row.key) === false) {
                errors[index] = {
                    key: ["Lütfen Etiket Seçiniz"]
                };
            }
            if (this.checkValid(row.val) === false) {
                errors[index] = {
                    val: ["Lütfen Değer Seçiniz"]
                };
            }
            return row;
        });

        return errors;
    };

    closeModal = () => {
    this.setState({ errors: { rows: [] } });
    if (this.props.closeInvoiceCustomModal) {
        this.props.closeInvoiceCustomModal();
    }
};
    saveInvoiceCustom = (rows) => {
        this.setState({ formData: rows });
    };
    onChange = data => {
        this.saveInvoiceCustom(data);
        this.props.saveInvoiceCustom(data);
    };

    addRow = () => {
        const { formData } = this.state;
        const { rows } = formData;
        const lastRowIndex = rows.length - 1;
        const updatedRow = {
            ...rows[lastRowIndex],
            id:null,key: "",val: ""
        };
        const updatedRows = [...rows.slice(0, lastRowIndex), updatedRow];
        this.setState({
            formData: {
                ...formData,
                rows: updatedRows,
            },
        });
        if (rows.length >= 5) {
            this.setState({ hideAddButton: false });
            return false;
        }
    };



    onRowDelete = () => {
        if(this.state.formData.rows.length<5){
            this.setState({ hideAddButton: true });
        }
        return false;
    };

    onChangeRow(index, value,input) {
        var data = this.state.formData;
        this.setState(
            {
                data:data
            }
        );
    }
    render() {
        return (
            <EkoModal
                bsSize={"large"}
                dialogClassName={""}
                showModal={this.props.showInvoiceCustomModal}
                title={"Fatura Özelleştirme Alanı"}
                onHide={this.closeModal.bind(this)}
                spinner={this.state.saving}
            >
                <EkoInputTable
                    onSave={this.onSave}
                    className={"modalTableFix"}
                    onCancel={this.closeModal}
                    onChange={this.onChange}
                    errors={this.state.errors}
                    formData={this.state.formData}
                    onRowAdd={this.addRow}
                    onRowDelete={this.onRowDelete}
                    hideAddButton={this.state.hideAddButton}
                    onChangeRow={this.onChangeRow.bind(this)}
                    data={{
                        headers: [{ label: "Etiket" }, { label: "Değer" }],
                        rows: this.state.formData.rows.map(() => this.row)
                    }}
                />
            </EkoModal>
        );
    }
}

export default InvoiceCustomerLineModal;
